module.exports = __webpack_public_path__ + "static/media/thumbnail.94d37291.jpg";